/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentDto } from '../../models/enrollment-dto';

export interface EnrollmentControllerFindAll$Params {
}

export function enrollmentControllerFindAll(http: HttpClient, rootUrl: string, params?: EnrollmentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentDto>>> {
  const rb = new RequestBuilder(rootUrl, enrollmentControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnrollmentDto>>;
    })
  );
}

enrollmentControllerFindAll.PATH = '/api/enrollment';
